import { Scroll } from '../../utilities/scroll/index';
function initReviewLink($container) {
    const $screen = $('html,body');
    const $reviews = $('.product-reviews');
    const reviewsContainer = '.js-toggle-reviews';
    const $reviewsHeadline = $container.find(reviewsContainer);
    let timeout = null;
    let scrollTo;

    $container.find('.js-show-reviews').on('click', function () {
        const scrollTo = $reviews.offset().top + 1;

        if (timeout) {
            clearTimeout(timeout);
        }

        if (!$reviews.hasClass('product-toggle--opened')) {
            $($reviewsHeadline[0]).trigger('click');
            timeout = setTimeout(function () {
                // $screen.animate({scrollTop: scrollTo}, 350);
                Scroll(document.querySelector('.product-toggle--opened'));
            }, 500);
        } else {
            Scroll(document.querySelector('.product-toggle--opened'));
            // $screen.animate({scrollTop: scrollTo}, 350);
        }
    });
}

export default initReviewLink;
